import { Box, useTheme } from '@mui/material';
import { CheckCircle, Clock, XCircle } from 'lucide-react';
import React from 'react';

interface NewActiveBadgeProps {
    isActive: boolean;
    label?: string;
    title?: string;
    size?: 'small' | 'medium';
    variant?: 'active' | 'inactive' | 'pending';
}

export default function New_ActiveBadge({ isActive, label, title, size = 'medium', variant }: NewActiveBadgeProps) {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    // Status-basierte Konfiguration
    const getStatusConfig = () => {
        if (variant === 'pending')
            return {
                color: theme.palette.warning.main,
                icon: Clock,
                bg: isDark ? 'rgba(255,152,0,0.15)' : 'rgba(255,152,0,0.1)',
                border: isDark ? 'rgba(255,152,0,0.3)' : 'rgba(255,152,0,0.2)',
                text: label || 'Pending',
            };

        if (isActive)
            return {
                color: theme.palette.success.main,
                icon: CheckCircle,
                bg: isDark ? 'rgba(76,175,80,0.15)' : 'rgba(76,175,80,0.1)',
                border: isDark ? 'rgba(76,175,80,0.3)' : 'rgba(76,175,80,0.2)',
                text: label || 'Active',
            };

        return {
            color: theme.palette.error.main,
            icon: XCircle,
            bg: isDark ? 'rgba(244,67,54,0.15)' : 'rgba(244,67,54,0.1)',
            border: isDark ? 'rgba(244,67,54,0.3)' : 'rgba(244,67,54,0.2)',
            text: label || 'Inactive',
        };
    };

    const config = getStatusConfig();
    const IconComponent = config.icon;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                px: 1,
                py: 0.5,
                borderRadius: 1,
                bgcolor: config.bg,
                border: `1px solid ${config.border}`,
                minWidth: size === 'small' ? 60 : 70,
                height: size === 'small' ? 20 : 24,
            }}
            title={title}
        >
            <Box sx={{ color: config.color, display: 'flex' }}>
                <IconComponent size={size === 'small' ? 12 : 14} />
            </Box>
            <Box
                sx={{
                    fontSize: size === 'small' ? '0.7rem' : '0.75rem',
                    fontWeight: 600,
                    color: isDark ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.8)',
                    lineHeight: 1,
                }}
            >
                {config.text}
            </Box>
        </Box>
    );
}
